import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as LicenseFeatureState from './license.state';

export const selectLicenseState =
  createFeatureSelector<LicenseFeatureState.LicenseState>(
    LicenseFeatureState.licenseFeatureKey
  );

export const selectLicenses = createSelector(
  selectLicenseState,
  LicenseFeatureState.selectAll
);

export const selectLicenseCount = createSelector(
  selectLicenseState,
  LicenseFeatureState.selectTotal
);
